import axios from 'axios'
import store from '../store'
import router from '../router'
import { Message } from 'element-ui'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 15000
})

function normalizeCode(value) {
  if (value == null || value === '') return null
  const code = Number(value)
  return Number.isNaN(code) ? null : code
}

function getResponseMessage(data) {
  if (!data) return ''
  if (typeof data === 'string') return data
  if (typeof data.message === 'string' && data.message) return data.message
  if (typeof data.msg === 'string' && data.msg) return data.msg
  return ''
}

function resolveErrorMessage(error) {
  const data = error.response && error.response.data
  const message = getResponseMessage(data)
  if (message) return message

  const status = error.response && error.response.status
  if (status === 400) return '请求参数错误'
  if (status === 401) return '未登录或登录已过期'
  if (status === 403) return '无权限访问'
  if (status === 404) return '请求的资源不存在'
  if (status >= 500) return '服务器错误'

  if (error.message && !/^Request failed with status code \d+$/.test(error.message)) {
    return error.message
  }
  return '网络错误'
}

function createApiError(message) {
  const error = new Error(message)
  error._errorShown = true
  return error
}

function notifyError(message, config) {
  if (!config || !config.skipErrorMessage) {
    Message.error(message)
  }
}

function handleUnauthorized(code) {
  if (code === 401) {
    store.dispatch('logout')
    router.push('/login')
  }
}

function rejectBusinessError(res, config) {
  const code = normalizeCode(res && res.code)
  const message = getResponseMessage(res) || (code === 400 ? '请求参数错误' : '请求失败')
  notifyError(message, config)
  if (code != null) {
    handleUnauthorized(code)
  }
  return Promise.reject(createApiError(message))
}

request.interceptors.request.use(config => {
  const token = store.state.token
  if (token) {
    config.headers.satoken = token
  }
  return config
})

request.interceptors.response.use(
  response => {
    const res = response.data
    const code = normalizeCode(res && res.code)
    if (code == null) {
      return res
    }
    if (code !== 200) {
      return rejectBusinessError(res, response.config)
    }
    return res
  },
  error => {
    const config = error.config || {}
    const data = error.response && error.response.data
    const businessCode = normalizeCode(data && data.code)
    const httpStatus = error.response && error.response.status
    const message = resolveErrorMessage(error)

    if (businessCode != null) {
      handleUnauthorized(businessCode)
    } else if (httpStatus === 401) {
      handleUnauthorized(401)
    }

    notifyError(message, config)
    return Promise.reject(createApiError(message))
  }
)

export default request
